import { useState } from "react";
import { AyudantiaInvestigacionData, solicitudAprobacionDTO, ResponseAprobacion, voidAyudantiaInvestigacionData } from "../../interfaces/AYUDANTIAS/Ayudantia";
import AcademicoService from "../../services/AcademicoService";
import AlertService from "../../services/AlertService";
import AyudantiaService from "../../services/AyudantiaService";
import { Button, Checkbox, Container, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import { MdCheck, MdClose, MdEditDocument, MdSearch } from "react-icons/md";
import { SmallModal } from "../../common/SmallModal";
import { Padding, Token } from "@mui/icons-material";
import { useAppSelector } from "../../redux/hooks";
import { AccionMultipleForm } from "../Formularios/AccionMultipleForm";
import { ResponseApi } from "../../types/ResponseApi";
import { FaLaptopHouse } from "react-icons/fa";
import { EstudianteActivoT, VoidEstudianteActivo } from "../../interfaces/SAAC/EstudianteActivo";
import { DatosGeneralesProyecto, VoidDatosGeneralesProyecto } from "../../interfaces/AYUDANTIAS/DatosGenProyecto";
import { format } from "date-fns";
import { es } from "date-fns/locale";

interface Props {
  solicitudes: AyudantiaInvestigacionData[],
  onActionAprobadas?: () => void,
  onActionPendientes?: () => void,
  onActionRechazadas?: () => void,
  rowsPerPage: Array<number>,
  showAcciones : boolean,
  tipoPersona : string
}

const ayudantiaService = new AyudantiaService();
const alertaService = new AlertService();
const academicoService = new AcademicoService();



export const TableSolicitudAyudVic: React.FC<Props> = ({ solicitudes, onActionAprobadas, onActionPendientes, onActionRechazadas, showAcciones,rowsPerPage, tipoPersona }) => {
    
    const [solicitudesAgregadas, setSolicitudesAgregadas] = useState<Array<AyudantiaInvestigacionData>>([]);
    const token = useAppSelector((state) => state.authReducer.token);
    const [page, setPage] = useState(0);
    const [rowsperpage, setRowsPerPage] = useState(rowsPerPage[0]);
    const [isModalRechazar, setIsModalRechazar] = useState<boolean>(false);
    const [isModalAceptar, setIsModalAceptar] = useState<boolean>(false);
    const [globalFilter, setGlobalFilter] = useState('');
    const [isModalDetalle, setIsModalDetalle] = useState<boolean>(false);
    const [detalleData, setDetalleData] = useState<AyudantiaInvestigacionData>(voidAyudantiaInvestigacionData());
    const [estudiante, setEstudiante] = useState<EstudianteActivoT>(VoidEstudianteActivo());
    const [datosProyecto, setDatosProyecto] = useState<DatosGeneralesProyecto>(VoidDatosGeneralesProyecto());

    const handleCheckSolicitud = (solicitud: AyudantiaInvestigacionData, event: React.ChangeEvent<HTMLInputElement>) => {
    setSolicitudesAgregadas((prevSelected) => 
        event.target.checked
        ? [...prevSelected, solicitud] // Agrega si está checkeado
        : prevSelected.filter(item => item.iddetallesolicitud !== solicitud.iddetallesolicitud) // Quita si se desmarca
        );
    };

    const handleOpenModal = async (data : AyudantiaInvestigacionData) => {
        alertaService.showLoading("Cargando información...");
        let DatosProyectos =  (await ayudantiaService.GetDatosGeneralesProyecto(token, data.idproyecto));
        setDatosProyecto(DatosProyectos.status.isSuccessfully ? DatosProyectos.data : VoidDatosGeneralesProyecto());
        let estudianteCarrera =  await academicoService.GetCarreraActivaByMatricula(token, data.codestudiante,'I');
        setEstudiante(estudianteCarrera.status.isSuccessfully ? estudianteCarrera.data : VoidEstudianteActivo());
        setDetalleData(data);
        setTimeout(() => {
          setIsModalDetalle(true);
          alertaService.hideLoading();
        }, 500);
      };

    const constFilteredSolicitud = solicitudes.filter((solicitud) => {
        if(solicitud.nombreProyecto.toUpperCase().includes(globalFilter.toUpperCase())  
            || solicitud.nombreEstudiante.toUpperCase().includes(globalFilter.toUpperCase()) 
            || solicitud.codestudiante.toUpperCase().includes(globalFilter.toUpperCase())
            || solicitud.nombreInvestigador.toUpperCase().includes(globalFilter.toUpperCase())
            || solicitud.fechasolicitud.toUpperCase().includes(globalFilter.toUpperCase())
            || solicitud.estadoPaso.toUpperCase().includes(globalFilter.toUpperCase())
            || solicitud.horasOtorgadas.toString().includes(globalFilter)
        ){
            return true;
        }
        return false;
    })

    const handleCheckAllSolicitudes = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSolicitudesAgregadas(event.target.checked ? [...solicitudes] : []);
    };

    const handleCloseModal = () => {
        document.activeElement instanceof HTMLElement && document.activeElement.blur();
        setIsModalDetalle(false);
      };
    

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleOpenModalRechazar = async () => {
        alertaService.showLoading("Procesando información...");
        setTimeout(() => {
          setIsModalRechazar(true);
          alertaService.hideLoading();
        }, 500);
    };
    
    const handleCloseModalRechazo = () => {
        document.activeElement instanceof HTMLElement && document.activeElement.blur();
        setIsModalRechazar(false);
    };

    const handleOpenModalAceptar = async () => {
        alertaService.showLoading("Procesando información...");
        setTimeout(() => {
          setIsModalAceptar(true);
          alertaService.hideLoading();
        }, 500);
    };
    
    const handleCloseModalAceptar = () => {
        document.activeElement instanceof HTMLElement && document.activeElement.blur();
        setIsModalAceptar(false);
    };

    const handleResponseFormRechazo = async (responseData: ResponseApi<solicitudAprobacionDTO>) => {
        if (responseData.status.isSuccessfully) {

          alertaService.alertaExito("éxito", "Se procesaron los datos correctamente.");
          setTimeout(() => {
            if(onActionPendientes)
              onActionPendientes()
            if(onActionRechazadas)
              onActionRechazadas()
          }, 1500);
        }
    };

    const handleResponseFormAceptar = async (responseData: ResponseApi<ResponseAprobacion>) => {
        if (responseData.status.isSuccessfully) {

            if(responseData.listData.length<=0){
                alertaService.alertaExito("éxito", "Se procesaron los datos correctamente.");
                setTimeout(() => {
                    if(onActionPendientes)
                        onActionPendientes()
                    if(onActionAprobadas)
                        onActionAprobadas()
                }, 1500);

            }else{
                //alertaService.hideLoading();
                let solicitudesNoAprobadas: string[] = [];

                responseData.listData.map((data)=>{
                let detalle = "Matricula: "+data.codestudiante+", Estudiante: "+data.nombreEstudiante+", Impedimentos: "+data.impedimentos;
                solicitudesNoAprobadas.push(detalle);
                })

                alertaService.alertaAdvertenciaListSolicitudes("Alerta",solicitudesNoAprobadas);
                setTimeout(() => {
                    if(onActionPendientes)
                        onActionPendientes()
                    if(onActionAprobadas)
                        onActionAprobadas()
                }, 1500);

            }

          
        }
    };

    function estadoTexto(estado:string):string{
        let texto = '';
        switch(estado){
          case 'P':
            texto = 'Pendiente';
            break;
          case 'A':
            texto = 'Aprobado';
            break;
          case 'N':
            texto = 'Rechazado';
            break;
          case 'X':
            texto = 'Anulada';
            break;
          case 'R':
            texto = 'Reservado-Aprobado';
            break;
          case 'E':
            texto = 'Reservado-Rechazado';
            break;
          case 'G':
            texto = 'Negado-Aprobado';
            break;
          default:
             return '';
        }
        return texto;
    }

    return(
        <Container>
            {
                showAcciones ?
                solicitudesAgregadas.length>0 ?
                <Grid container spacing={1}>
                    <Grid item>
                        <Button size="small"
                            variant="contained"
                            sx={{
                                marginRight: 1, backgroundColor: "#F44336",
                                color: "#FFFFFF !important",
                                "&:hover": { backgroundColor: "#E57373" },
                                boxShadow: 3, margin: "10px"
                            }}
                            
                            endIcon={<MdClose />}
                                onClick={()=>{handleOpenModalRechazar()}}
                            >
                            Rechazar todo
                        </Button>
                    </Grid>
                    <Grid item>
                        <Button size="small"
                            variant="contained"
                            sx={{
                            marginRight: 1, backgroundColor: "#4CAF50",
                            color: "#FFFFFF !important",
                            "&:hover": { backgroundColor: "#81C784" },
                            boxShadow: 3, margin: "10px"
                            }}
                            endIcon={<MdCheck />}
                            onClick={()=>{handleOpenModalAceptar()}}
                            >
                            Aceptar todo
                        </Button>

                    </Grid>
                </Grid>
                :null
                : null
            }

            <TextField
                variant="outlined"
                size="small"
                label="Busqueda General"
                //value={searchTerm}
                onChange={(e) => setGlobalFilter(e.target.value.toString())}
                sx={{ width: 300 }}
            />
            <br />
            <br />

            <TableContainer component={Paper} elevation={3}>
                <Table>
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "#243165" }}>
                            {
                                showAcciones ?
                                <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                    <Checkbox onChange={(event) => handleCheckAllSolicitudes(event)}/>
                                </TableCell>
                                : null
                            }
                            
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del proyecto</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Ayudante</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Matrícula</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Nombre del Investigador</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Fecha de la solicitud</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Estado</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>Horas otorgadas</TableCell>
                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                    Acciones
                                </TableCell>


                        </TableRow>

                    </TableHead>
                    <TableBody>
                        {
                            solicitudes.length>0?
                            (
                                constFilteredSolicitud.slice(page * rowsperpage, page * rowsperpage + rowsperpage).map((solicitud, index)=>(
                                    <TableRow key={index}>
                                        {
                                            showAcciones ?
                                            <TableCell align="left" sx={{ color: "#FFFFFF", fontWeight: "bold" }}>
                                                <Checkbox checked={solicitudesAgregadas.some(item => item.iddetallesolicitud === solicitud.iddetallesolicitud)}
                                                    onChange={(event) => handleCheckSolicitud(solicitud,event)}
                                                />
                                            </TableCell>
                                            :null
                                        }
                                        
                                        <TableCell>{solicitud.nombreProyecto}</TableCell>
                                        <TableCell>{solicitud.nombreEstudiante}</TableCell>
                                        <TableCell>{solicitud.codestudiante}</TableCell>
                                        <TableCell>{solicitud.nombreInvestigador}</TableCell>
                                        <TableCell>{solicitud.fechasolicitud.toString()}</TableCell>
                                        <TableCell>{estadoTexto(solicitud.estadoPaso)}</TableCell>
                                        <TableCell>{solicitud.horasOtorgadas}</TableCell>
                                        <TableCell>
                                            <Grid>
                                                <Tooltip title={'Detalle'} placement="top" arrow>
                                                    <IconButton aria-label={'Detalle'}  color="primary" onClick={()=>{handleOpenModal(solicitud)}}>
                                                    <MdEditDocument />
                                                    </IconButton>
                                                </Tooltip>
                                            </Grid>
                                        </TableCell>

                                    </TableRow>
                                ))
                            )
                            
                            :
                            (
                                <TableRow>
                                    <TableCell colSpan={9} align="center">
                                        No hay solicitudes registradas.
                                    </TableCell>
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={rowsPerPage}
                component="div"
                count={constFilteredSolicitud.length}
                rowsPerPage={rowsperpage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />

            <SmallModal 
                title='Solicitudes a rechazar'
                open={isModalRechazar}
                onClose={handleCloseModalRechazo}
                content = {<>
                <ul>
                {
                    solicitudesAgregadas.map((obj, index)=>(
                    <li key={index}>
                        <p> <b>Estudiante: </b>{obj.nombreEstudiante +" "} <b>Proyecto: </b>{ obj.nombreProyecto+" " } <b>Investigador: </b>{obj.nombreInvestigador}</p>
                    </li>
                    ))
                }
                </ul>
                <AccionMultipleForm data={solicitudesAgregadas} token={token} onClose={handleCloseModalRechazo } onResponse={handleResponseFormRechazo} tipoPersona={tipoPersona} aceptar={false}/>
                </>}
            />

            <SmallModal 
                title='Solicitudes a aceptar'
                open={isModalAceptar}
                onClose={handleCloseModalAceptar}
                content = {<>
                <ul>
                {
                    solicitudesAgregadas.map((obj, index)=>(
                    <li key={index}>
                        <p> <b>Estudiante: </b>{obj.nombreEstudiante +" "} <b>Proyecto: </b>{ obj.nombreProyecto+" " } <b>Investigador: </b>{obj.nombreInvestigador}</p>
                    </li>
                    ))
                }
                </ul>
                <AccionMultipleForm data={solicitudesAgregadas} token={token} onClose={handleCloseModalAceptar } onResponse={handleResponseFormAceptar} tipoPersona={tipoPersona} aceptar={true}/>
                </>}
            />

            <SmallModal
                    title='Detalle de la solicitud'
                    open={isModalDetalle}
                    onClose={handleCloseModal}
                    content = {
                      <>
                        <Container component={Paper} elevation={3}>
                          <Typography variant="h6" sx={{ marginTop: 2 }}>
                            Datos Generales
                          </Typography>
                          <Typography variant="body1"><strong>Titulo:</strong> {datosProyecto.tituloProyecto}</Typography>
                          <Typography variant="body1"><strong>Código de proyecto:</strong> {datosProyecto.codigoProyecto}</Typography>
                          <Typography variant="body1"><strong>Fecha de inicio:</strong> {format(new Date(datosProyecto.fechaInicio), 'dd/MMM/yyyy',{locale: es})}</Typography>
                          <Typography variant="body1"><strong>Fecha de fin:</strong> {format(new Date(datosProyecto.fechaFinal), 'dd/MMM/yyyy',{locale: es})}</Typography>
                          <Typography variant="body1"><strong>Objetivo general:</strong>{datosProyecto.objetivoGeneral}</Typography>
                        </Container>
            
                        <Container component={Paper} elevation={3}>
                          <Typography variant="h6" sx={{ marginTop: 2 }}>
                            Datos de la solicitud
                          </Typography>
                          <Typography variant="body1"><strong>Estudiante: </strong> {detalleData.nombreEstudiante}</Typography>
                          <Typography variant="body1"><strong>Carrera: </strong> {estudiante.nombrecarrera}</Typography>
                          <Typography variant="body1"><strong>Descripción de la necesidad: </strong> {detalleData.descripcion}</Typography>
                          <Typography variant="body1"><strong>Fecha de la solicitud: </strong> {detalleData.fechasolicitud}</Typography>
                          <Typography variant="body1"><strong>Término: </strong>{detalleData.termino}</Typography>
                          <Typography variant="body1"><strong>Responsable: </strong>{detalleData.nombreInvestigador}</Typography>
                          <Typography variant="body1"><strong>Financiamiento: </strong>{detalleData.financiamientoTexto}</Typography>
                          <Typography variant="body1"><strong>{detalleData.estadoPaso === "P" || detalleData.estadoPaso === "A"  ? 'Horas otorgadas: ':'Horas de la solicitud: ' }  </strong>{ detalleData.estadoPaso === 'P' || detalleData.estadoPaso === 'A' ? detalleData.horasOtorgadas : detalleData.horas}</Typography>
                          <Typography variant="body1"><strong>Actividades: </strong>{detalleData.actividades}</Typography>
                        </Container>
                      </>
                      
                    }
                  
                  />


            
        </Container>
    );


}
